// extracted by mini-css-extract-plugin
module.exports = {"root":"AcceptanceNotificationCard_root__1x6oZ","title":"AcceptanceNotificationCard_title__NVe63","text":"AcceptanceNotificationCard_text__2lEYI"};